import { Inject, Injectable } from '@angular/core';
import { BaseEndpoint } from '../app.constants';
import { Http } from '@angular/http';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { PropertyState, Region, Subregion } from './loanofficerregionreference.model';

@Injectable()
export class LoanOfficerRegionReferenceService
{

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService) { }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }

    getRegionAssignmentStrategiesByGroup(groupName: string): Promise<Region[]> {
        var url = this.baseApiUrl + 'v1/getregionassignmentstrategiesbygroup/' + groupName;
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as Region[];
            })
            .catch(this.handleError);
    }

    getPropertyStates(): Promise<PropertyState[]> {
        var url = this.baseApiUrl + 'v1/propertyState/readcollection/';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as Region[];
            })
            .catch(this.handleError);
    }
}






// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/loanofficerregionreference.service.ts